import React from 'react'
import TextInput from '../../../components/UIComponent/TextInput'
import ExpandableGroup from '../../../components/ExpandableGroup'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import DateRangeField from '../../../components/dateRangeField/DateRangeField'
import ToggleSwitch from '../../../components/common/ToggleSwitch'

function ProfitLossUI(props) {
    const safeAmount = (val) => (Number(val) || 0).toLocaleString("en-IN");

    const totalExpenses = props.profitLossData.totalAssets;
    const totalIncome = props.profitLossData.totalLiabilities;
    const net = Math.abs(totalIncome) - Math.abs(totalExpenses);
    const isLoss = net < 0;

    return (
        <div className='profitloss bg-white rounded-[10px] border-2 border-gray-200 overflow-hidden'>

            <div className='search-area px-2.5 py-[10px] border-b-2 border-gray-100'>
                <div className='grid grid-cols-[0.8fr_0.8fr_0.5fr_1fr] gap-4'>
                    <div className="input-grp">
                        <label>From Date</label>
                        <TextInput
                            type="date"
                            id="fromDate"
                            name="fromDate"
                            value={props.profitObject.fromDate}
                            handleChange={(event) => props.handleChange(event, "fromDate")}
                            className={props.validState?.error?.fromDate ? "error" : ""}
                        />
                    </div>

                    <div className="input-grp">
                        <label>To Date</label>
                        <TextInput
                            type="date"
                            id="toDate"
                            name="toDate"
                            value={props.profitObject.toDate}
                            handleChange={(event) => props.handleChange(event, "toDate")}
                            className={props.validState?.error?.toDate ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp flex gap-[10px] items-center pt-5'>
                        <label>Include Zero Values:</label>
                        <ToggleSwitch
                            checked={props.profitObject.includeZero}
                            onChange={(e) => props.handleChange(e, "includeZero")}
                        />
                    </div>
                    <div className='btn-grp mt-5'>
                        <button
                            onClick={() => props.getProfitLossReport()}
                            className='prm-btn'>Search</button>
                    </div>
                </div>
            </div>

            <div className='report-area p-2.5 overflow-hidden overflow-y-auto'
                style={{ maxHeight: "calc(100dvh - 235px)", height: "100%" }}
            >
                <div className='grid grid-cols-2 gap-2.5'>

                    <div className='expense bg-orange-50 rounded-lg border border-orange-200 overflow-hidden h-fit'>
                        <div className='px-4 py-[8px] border-b border-orange-200 flex items-center justify-between'>
                            <h2 className='text-[18px] font-semibold text-orange-900'>
                                Expenses
                            </h2>
                            <p className='text-[16px] text-orange-900 font-normal'>Total: <span className='font-semibold'>₹ {safeAmount(Math.abs(props.profitLossData.totalAssets))}</span></p>
                        </div>

                        <div className='p-2.5 space-y-2'>
                            {props.profitLossData.expenses.map((group, index) => (
                                <ExpandableGroup
                                    key={index}
                                    title={group.name}
                                    total={group.amount}
                                    items={group.sub}
                                    theme="orange"
                                    onItemClick={(item) => props.redirectToLedger(item)}
                                />
                            ))}
                        </div>
                    </div>

                    <div className='income bg-green-50 rounded-lg border border-green-200 overflow-hidden h-fit'>
                        <div className='px-4 py-[8px] border-b border-green-200 flex items-center justify-between'>
                            <h2 className='text-[18px] font-semibold text-green-900'>
                                Income
                            </h2>
                            <p className='text-[16px] text-green-900 font-normal'>Total: <span className='font-semibold'>₹ {safeAmount(Math.abs(props.profitLossData.totalLiabilities))}</span></p>
                        </div>

                        <div className='p-2.5 space-y-2'>
                            {props.profitLossData.income.map((group, index) => (
                                <ExpandableGroup
                                    key={index}
                                    title={group.name}
                                    total={group.amount}
                                    items={group.sub}
                                    theme="green"
                                    onItemClick={(item) => props.redirectToLedger(item)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className={`flex items-center gap-3 p-2.5 border-t-2 border-gray-100 ${isLoss ? 'bg-red-50' : 'bg-green-50'}`}>
                <div className={`w-[25px] h-[25px] ${isLoss ? 'bg-red-500' : 'bg-green-500'} rounded-md flex items-center justify-center`}>
                    <FontAwesomeIcon icon={isLoss ? faTriangleExclamation : faCheckCircle} className='text-white text-[14px]' />
                </div>
                <p className={`text-[14px] font-medium ${isLoss ? 'text-red-700' : 'text-green-700'}`}>
                    {isLoss ? 'Net Loss' : 'Net Profit'} as per Profit & Loss Account:
                    <span className='font-semibold ml-1'>₹ {safeAmount(Math.abs(net))}</span>
                </p>
            </div>
        </div>
    )
}

export default ProfitLossUI
